import styled from 'styled-components';

export const FloatingButton = styled.button`
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 64px;
  height: 64px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 25;
  padding: 0;
  overflow: hidden;
  background: transparent;
`;

export const FloatingButtonIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const WidgetPanel = styled.div<{ isOpen: boolean }>`
  position: fixed;
  right: 24px;
  bottom: 92px;
  width: min(420px, calc(100vw - 32px));
  height: min(620px, calc(100vh - 120px));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 20px;
  background: ${({ theme }) => theme.colors.surface};
  box-shadow: 0 18px 42px ${({ theme }) => `${theme.colors.onBackground}25`};
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  pointer-events: ${({ isOpen }) => (isOpen ? 'auto' : 'none')};
  transform: ${({ isOpen }) => (isOpen ? 'translateY(0)' : 'translateY(16px)')};
  transition: opacity 0.2s ease, transform 0.2s ease;
  z-index: 25;

  @media (max-width: 768px) {
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    border-radius: 0;
  }
`;

export const WidgetHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => `${theme.colors.onBackground}12`};
`;

export const WidgetTitle = styled.div`
  font-size: 1.4rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.onSurface};
`;

export const WidgetActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IconButton = styled.button`
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${({ theme }) => `${theme.colors.onBackground}10`};
  color: ${({ theme }) => theme.colors.onSurface};

  svg {
    font-size: 1.8rem;
    color: inherit;
  }
`;

export const WidgetFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  background: ${({ theme }) => theme.colors.background};
`;

export const ExternalOnlyContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px;
  text-align: center;
  background: ${({ theme }) => theme.colors.background};
`;

export const ExternalOnlyIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => `${theme.colors.primary}15`};

  svg {
    font-size: 2.6rem;
    color: inherit;
  }
`;

export const ExternalOnlyTitle = styled.div`
  font-size: 1.8rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.onSurface};
`;

export const ExternalOnlyDescription = styled.p`
  max-width: 320px;
  margin: 0;
  font-size: 1.4rem;
  line-height: 1.5;
  color: ${({ theme }) => `${theme.colors.onSurface}cc`};
`;

export const PrimaryExternalLinkButton = styled.a`
  min-height: 44px;
  padding: 0 18px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 1.3rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.surface};
  background: ${({ theme }) => theme.colors.primary};
`;

export const WidgetFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 10px 16px 14px;
  border-top: 1px solid ${({ theme }) => `${theme.colors.onBackground}10`};
`;

export const ExternalLinkButton = styled.a`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
`;